import { render, staticRenderFns } from "./RequestSpecialistSidebar.vue?vue&type=template&id=32935c2d"
import script from "./RequestSpecialistSidebar.vue?vue&type=script&lang=js"
export * from "./RequestSpecialistSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports